import * as path from 'node:path';
import { createHash } from 'node:crypto';
import type { AbilityDiskReader } from './head.js';
import type { InstalledMarker } from './materialize.js';

export type DiscVerdict = 'ok' | 'tampered' | 'no-map' | 'missing-marker';

/** At-rest disc verification (spec I4): compare every file named in the
 *  marker's content map against disk. Extra files on disk are tolerated
 *  (user notes etc. don't corrupt a disc); missing or altered mapped files
 *  are tamper. Old markers without a map verify as 'no-map' (shallow-only)
 *  and get upgraded on their next materialize. */
export async function verifyDiscOnDisk(dir: string, reader: AbilityDiskReader): Promise<DiscVerdict> {
  const raw = await reader.readFile(path.posix.join(dir, '.installed'));
  if (!raw) return 'missing-marker';
  let marker: InstalledMarker;
  try { marker = JSON.parse(raw) as InstalledMarker; } catch { return 'missing-marker'; }
  if (!marker.files) return 'no-map';
  for (const [rel, expected] of Object.entries(marker.files)) {
    const content = await reader.readFile(path.posix.join(dir, rel));
    if (content === null) return 'tampered';
    if (createHash('sha256').update(content).digest('hex') !== expected) return 'tampered';
  }
  return 'ok';
}
